﻿import * as $ from 'jquery';
import { bind, canWrite, Binding } from 'common/dom/binding';
import { Observable } from 'common/barrels/rx';
import { compositeSubscription } from 'common/barrels/core';
import { textbox as textInput, textarea, passwordbox as passwordInput } from 'common/barrels/dom';

import 'common/styles/controls/textbox.less';

function updateIfDifferent($input: JQuery, x: string) {
    if ($input.val() !== x)
        $input.val(x);
}

function textInputStream($input: JQuery): Observable<string> {
    return Observable.fromEvent<any>($input, 'input propertychange').map(() => $input.val());
}

export function textbox(value: Binding<string>, multiline = false) {
    const $input = multiline ? textarea() : textInput();

    if (!canWrite(value))
        $input.attr('readonly', 'true');

    return $input.owns(bind<string>(value, x => updateIfDifferent($input, x), () => textInputStream($input)));
}

export function validatedTextbox(value: Binding<string>, validator: (x: string) => Observable<string>, validChangedCallback: (x: boolean) => void = null) {
    const $input = textInput();

    if (!canWrite(value))
        throw new Error('validatedTextboxes can only be bound to writable streams!');

    const rawInputValues = textInputStream($input);

    const inputValuesWithValidationResults = rawInputValues.switchMap(x => validator(x), (x, y) => ({ value: x, validationResult: y })).share();

    const validValues = inputValuesWithValidationResults.filter(x => x.validationResult === null).map(x => x.value);

    return $input.owns(compositeSubscription(
        bind<string>(value, x => updateIfDifferent($input, x), () => validValues),

        inputValuesWithValidationResults.subscribe(x => $input.attr('title', x.validationResult)),

        inputValuesWithValidationResults.map(x => x.validationResult === null).distinctUntilChanged().subscribe(x => {
            $input.toggleClass('common-textbox-invalid', !x);

            if (validChangedCallback)
                validChangedCallback(x);
        })
    ));
}

export function passwordbox(value: Binding<string>) {
    const $input = passwordInput();

    if (!canWrite(value))
        $input.attr('readonly', 'true');

    return $input.owns(bind<string>(value, x => updateIfDifferent($input, x), () => textInputStream($input)));
}